@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.scheduleButton,
.submitButton {
  border: none;
  box-shadow: none;
  border-radius: 7px;

  &:hover,
  &:focus,
  &:focus-visible,
  &:disabled {
    border: none;
  }
}

.refineButton {
  @include typography-v2-title-sm;
  @include border-radius-r2;
  color: var(--text-default);
  border: 1px solid var(--border-default);
}

.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actionButtonsContainer {
  @include border-radius-r2;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--border-soft);
}
